import { Component } from '@angular/core';

@Component({
  selector: 'unicon-conversion-rate-card',
  templateUrl: './conversion-rate-card.component.html',
})
export class ConversionRateCardComponent {}
